import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'
import {
  start_case
} from '../../../Functions/Strings'

const TableCellPrenom = ({
  item,
  label,
  device
}) => {
  const value = start_case(item.prenom)
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        value={value}
      />
    : <TableCellDesktop
        max={150}
        value={value}
      />
}

export default TableCellPrenom
